import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var UserApps = function UserApps(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2ZM17 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM8.293 13.293a1 1 0 0 1 1.404-.01l.008.007a2.693 2.693 0 0 0 .492.315c.378.19.976.395 1.803.395s1.425-.206 1.803-.394a2.691 2.691 0 0 0 .492-.316l.008-.007a1 1 0 0 1 1.404 1.424L15 14l.707.707-.001.002-.002.001-.003.003-.008.008-.02.02a3.383 3.383 0 0 1-.26.216 4.7 4.7 0 0 1-.716.437c-.622.312-1.524.606-2.697.606s-2.075-.294-2.697-.606a4.697 4.697 0 0 1-.716-.438 3.412 3.412 0 0 1-.26-.215l-.02-.02-.008-.008-.003-.003-.002-.002L9 14l-.706.708a1 1 0 0 1-.001-1.415Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm-7 9a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z",
      fill: color
    })]
  });
};
export default UserApps;